<template>
  <div>
    <!-- For free text -->
    <ValidationProvider
      :vid="`questionfreetext`"
      name="Question Free Text"
      rules="required"
      v-slot="{ errors }"
    >
      <b-field :type="errors.length > 0 ? 'is-danger' : null">
        <ckeditor v-model="data.questionFreeText" :config="editorConfig" />
      </b-field>
      <span class="required">{{ errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      default: () => {}
    }
  },
  data() {
    return {
      editorConfig: {
        // The configuration of the editor.
        extraAllowedContent: "div[class]",
        allowedContent: true,
        // filebrowserUploadMethod: "form",
        // filebrowserUploadUrl: process.env.VUE_APP_BACKEND_URL + "/api/ckeditor/upload-image",
        extraPlugins: "justify,font"
      }
    };
  }
};
</script>
